import { CATEGORIES } from "@/lib/api";

const field = "w-full bg-black/40 border border-white/10 rounded px-3 py-2 text-sm focus:border-amber-500/60 outline-none transition-colors";

export default function NewsForm({ form, setForm, editing, onSubmit, onCancel }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="news-form">
      <h2 className="font-display text-2xl text-amber-100">{editing ? "Edytuj wpis" : "Nowy wpis"}</h2>
      <input className={field} placeholder="Tytuł" value={form.title} onChange={set("title")} data-testid="news-title-input" />
      <select className={field} value={form.category} onChange={set("category")} data-testid="news-category-select">
        {Object.entries(CATEGORIES).map(([k, l]) => <option key={k} value={k} className="bg-[#11141c]">{l}</option>)}
      </select>
      <textarea className={`${field} h-40 resize-none`} placeholder="Treść" value={form.content} onChange={set("content")} data-testid="news-content-input" />
      <div className="flex gap-2">
        <button className="px-5 py-2 bg-amber-500 text-white font-bold rounded hover:bg-amber-400 transition-colors text-sm" data-testid="news-submit-btn">{editing ? "Zapisz" : "Dodaj"}</button>
        {editing && <button type="button" onClick={onCancel} className="px-4 py-2 border border-white/10 rounded text-sm hover:bg-white/5" data-testid="news-cancel-btn">Anuluj</button>}
      </div>
    </form>
  );
}
